export default "<p>fmtdia works!</p>\n"